import type { TrailSource } from '@/domain/events/schemas';

export const eventsTrailKeys = {
  all: ['eventsTrail'] as const,
  list: (companyId: string, source: TrailSource, entityId: string | undefined, params: Record<string, unknown>) =>
    [...eventsTrailKeys.all, 'list', companyId, source, entityId ?? null, params] as const,
  filters: (companyId: string, source: TrailSource) => [...eventsTrailKeys.all, 'filters', companyId, source] as const,
  newEvents: (companyId: string, source: TrailSource, entityId: string | undefined, token: string | null) =>
    [...eventsTrailKeys.all, 'newEvents', companyId, source, entityId ?? null, token] as const,
};
